module.exports = __webpack_public_path__ + "img/green_138.b4e34181.png";